const hasNoStock = ({ stock }) => stock <= 0

/*
 * Definition of "low stock" according to Looker "Product Availability" dashboard:
 * => less than half of the size curve available
 */
export const determineIfLowStock = skus => skus.filter(hasNoStock).length > skus.length / 2

export const determineIfNoStock = skus => skus.every(hasNoStock)

export const determineIfSoldOut = (skus, isRaffle, hasRaffleEnded) =>
  determineIfNoStock(skus) || (isRaffle && hasRaffleEnded)

export const determineIfLastChance = (skus, isBackorderable) =>
  determineIfLowStock(skus) && !isBackorderable
